export const markReadOrUnreadButtonClass = 'mark-read-or-unread-button';

export const notificationCodeTokenClass = 'notification-code-token';

